import React from 'react';
import Select from 'react-select';

const SearchableSelect = ({ children, name, value, onChange, placeholder = "Select...", id }) => {
  // Parse children to extract options
  const options = React.Children.toArray(children)
    .filter(child => child.type === 'option')
    .map(child => ({
      value: child.props.value,
      label: child.props.children
    }));

  const selectedOption = options.find(opt => opt.value === value) || null;

  const handleChange = (selected) => {
    // Mimic the native event object so existing onChange handlers work
    const event = {
      target: {
        name: name,
        value: selected ? selected.value : ''
      }
    };
    if (onChange) {
      onChange(event);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '40px',
      borderRadius: '8px',
      border: state.isFocused ? '1px solid #22c55e' : '1px solid #d1d5db',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(34, 197, 94, 0.1)' : 'none',
      fontSize: '14px',
      fontFamily: 'inherit',
      padding: '0 4px',
      transition: 'border-color 0.2s',
      cursor: 'pointer',
      '&:hover': {
        borderColor: state.isFocused ? '#22c55e' : '#d1d5db'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '8px',
      color: '#6b7280'
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      backgroundColor: state.isSelected ? '#154530' : state.isFocused ? '#f3f4f6' : 'white',
      color: state.isSelected ? 'white' : '#374151',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: state.isSelected ? '#154530' : '#e5e7eb'
      }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      zIndex: 9999
    })
  };

  return (
    <Select
      id={id}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      styles={customStyles}
      placeholder={placeholder}
      isClearable={false}
      isSearchable={true}
    />
  );
};

export default SearchableSelect;
